 import API_URL from '../../constants/API_URL.js';
const axios = require('axios');
export const CLIENT_BY_ID = 'CLIENT_BY_ID';
export const CLIENT_BY_ID_PROGRESS = 'CLIENT_BY_ID_PROGRESS';

const getClientByIdAction = data => ({
    type: CLIENT_BY_ID,
    data,
});

export const clientById = (id,clientlogo,logoContentType) => (dispatch) => {
    dispatch({ type: CLIENT_BY_ID_PROGRESS });
localStorage.setItem('clientId',id)
    let a = {
        method: 'GET',
        url: API_URL + "clientByID",
        params: {
            clientId: id,
            lang: localStorage.getItem("lang")
        },
        headers: {
            'Authorization': localStorage.getItem('tokenType') + ' ' + localStorage.getItem('accessToken'),
            'Content-Type': 'application/json'
        }
    }
    axios(a).then(res => {
        let client = {
            clientName: res.data.object.name,
            clientId: id,
        }
 
        localStorage.setItem('client_name',res.data.object.name)
        let clientImage = `${API_URL}getProductImage?clientName=${localStorage.getItem('client_name')}&imageName=${clientlogo}&imageContent=${logoContentType}` 
        localStorage.setItem("clientLogo",clientImage);
        dispatch(getClientByIdAction(client))
    }).catch(err => {
        dispatch(getClientByIdAction(err))
    })
}
